import { schema } from "normalizr";

const shortcut = new schema.Entity(`shortcuts`);
const arrayOfShortcuts = [shortcut];

export { shortcut, arrayOfShortcuts };
